import React from 'react';
import {Disclosure} from '@headlessui/react';
import {Link} from 'react-scroll';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export default function NavBar() {
  const navigation = [
    {
      name: 'Sobre mí',
      href: 'About',
      current: false,
    },
    {
      name: 'Proyectos',
      href: 'Projects',
      current: false,
    },
    {
      name: 'Contacto',
      href: 'Contact',
      current: false,
    },
  ];

  return (
    <Disclosure as="nav" className="bg-gray-800 fixed w-full">
      <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
        <div className="relative flex h-16 items-center justify-between">
          <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-center">
            <div className="flex space-x-4">
              {navigation.map(item => (
                <Link
                  to={item.href}
                  key={item.name}
                  href={item.href}
                  // onClick={item.onClick}
                  className={classNames(
                    item.current
                      ? 'bg-gray-900 text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white',
                    'px-3 py-2 rounded-md text-sm font-medium',
                  )}
                  aria-current={item.current ? 'page' : undefined}>
                  {item.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Disclosure>
  );
}
